import React from 'react';
import './year2SquadCreator.css';

export default function Year2PortfolioCohortCards({
  schoolName,
  cohorts,
  loading,
  onBack,
  onSelectCohort,
}) {
  if (loading) {
    return (
      <div className="placeholder-card">
        <p>Loading Year 2 cohorts…</p>
      </div>
    );
  }

  return (
    <div>
      <button type="button" className="btn-form-toggle-outlined" onClick={onBack} style={{ marginBottom: '16px' }}>
        ← Back to schools
      </button>

      <div className="year2-page-header">
        <h2 className="year2-page-title">{schoolName}</h2>
        <p className="year2-page-subtitle">
          {cohorts.length} Year 2 cohort{cohorts.length === 1 ? '' : 's'} — select a cohort to review portfolio seal readiness
        </p>
      </div>

      {cohorts.length === 0 ? (
        <div className="placeholder-card">
          <p>No Year 2 cohorts available for this school.</p>
        </div>
      ) : (
        <div className="year2-cohort-grid">
          {cohorts.map((cohort) => {
            const cohortId = cohort.cohort_id ?? cohort.id;
            const cohortName = cohort.cohort_name ?? cohort.name;
            return (
              <div key={cohortId} className="year2-cohort-card" style={{ cursor: 'default' }}>
                <div className="year2-card-header">
                  <div>
                    <h3 className="year2-card-title">{cohortName}</h3>
                    <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-muted)' }}>
                      {schoolName} · {cohort.student_count ?? 0} students
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-primary-action"
                  style={{ width: '100%', marginTop: '12px' }}
                  onClick={() => onSelectCohort(cohort)}
                >
                  Review portfolio
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
